








import { Component, mixins } from '@niknevis/vue-modules'
import AdminAgentSearch from '@/modules/user/components/admin/AdminAgentSearch.vue'
import { FilterEntitySearchMixin } from '@/modules/common/filter/mixins/filterEntitySearchMixin'

@Component({
  components: {
    AdminAgentSearch
  }
})
export default class AdminAgentSearchFilter extends mixins(FilterEntitySearchMixin) {

}
